<script>
    import axios from 'axios'
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import Button from "primevue/button";
    import Checkbox from "primevue/checkbox";
    import Divider from "primevue/divider";
    import {FormatHelper} from "../../../helpers/FormatHelper";
    import {UploadConstants} from "../../../constants/uploadConstants";

    export default {
        data() {
            return {
                loading: false,
                maxSize: UploadConstants.MAX_UPLOAD_SIZE,
                allowExtensions: UploadConstants.ALLOW_IMPORT_FILE_EXTENSIONS,
                model: {},
                locale: window.locale
            }
        },
        props: ["name", "reportRid", "type", "target"],
        methods: {
            onOpen() {
                if (this.target === "all") {
                    this.model = {
                        organic: true,
                        context: true,
                    };
                } else {
                    this.model = {
                        organic: this.target === "organic",
                        context: this.target === "context",
                    };
                }
            },
            onClose() {
                this.$upload.reset(this.key);
            },
            upload() {
                if (this.$upload.meta(this.key).state === 'sending') {
                    return;
                }

                this.$upload.start(this.key);
            },
            onClickButtonAction() {
                this.$upload.reset(this.key);
                this.$upload.select(this.key);
            },
            onUpload() {
                window.location.reload();
            }
        },
        computed: {
            getApiUrl() {
                return this.$config.API_URL + '/report/group/' + this.type + '/file/' + this.reportRid;
            },
            error() {
                if (this.$upload.files(this.key).error.length) {
                    switch (this.$upload.files(this.key).error[0].error.code) {
                        case "file-max-size":
                            return this.$t('lang.group_report.file_size_err', [FormatHelper.number(this.maxSize)]);
                        case "file-extension":
                            return this.$t('lang.group_report.file_type_err', [this.allowExtensions.join(", ")]);
                      default:
                            return this.$upload.files(this.key).error[0].error.msg;
                    }
                }

                return null;
            },
            key() {
                return 'key_' + this.type;
            },
            btnModalLabel() {
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            isDisabledButtonAction() {
                return this.$upload.meta(this.key).state === 'sending' || this.$upload.meta(this.key).state === 'complete';
            },
            getLabelButtonAction() {
                switch (this.$upload.meta(this.key).state) {
                    case 'sending':
                        return this.$t('lang.main.btn.loading') + '...';
                    case 'ready':
                        return this.$t('lang.main.btn.choose') + '...';
                    case 'error':
                        return this.$t('lang.main.btn.choose') + '...';
                }
            },
            getOrganicLabel() {
                return this.type === 'import' ? this.$t('lang.main.f_import_organic') : this.$t('lang.main.f_delete_organic');
            },
            getContextLabel() {
                return this.type === 'import' ? this.$t('lang.main.f_import_context') : this.$t('lang.main.f_delete_context');
            },
        },
        created() {
            let self = this;
            this.$upload.on(this.key, {
                startOnSelect: false,
                extensions: self.allowExtensions,
                maxSizePerFile: self.maxSize,
                url: this.getApiUrl,
                http: (data) => {
                    data.body.append('organic', self.model.organic);
                    data.body.append('context', self.model.context);

                    this.loading = true;
                    axios({
                        method: 'post',
                        url: data.url,
                        withCredentials: true,
                        data: data.body,
                    }).then(data.success, data.error)

                },
                parseErrors(res) {
                    return [{code: 'fileError', msg: res.response.data.message}];
                },
                onSuccess() {
                    this.loading = false;
                    window.location.reload();
                },
                onError() {
                    this.loading = false;
                },
            });
        },
        components: {
            AdaptersDialog,
            Button,
            Checkbox,
            Divider,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.group_report.select_file')"
        :loading="loading"
        :error-message="error"
        :callback-agree="upload"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <div>
                <p>{{$t('lang.group_report.select_file_help')}} <a :href="'/resources/' + locale + '/sample.txt'" target="_blank">{{$t('lang.group_report.select_file_example')}}</a></p>
            </div>
            <div class="mb-3">
                <Button
                    @click="onClickButtonAction"
                    :disabled="isDisabledButtonAction"
                    :label="getLabelButtonAction"
                    size="small"
                    class="mb-1"
                />
                <span class="info" style='text-align: left; display: block;' v-for="file in $upload.files(key).all">{{ file.name }}</span>
            </div>
            <Divider />
            <div class="formgroup-inline">
                <div class="field-checkbox">
                    <Checkbox v-model="model.organic" inputId="organic" binary />
                    <label for="organic">{{ getOrganicLabel }}</label>
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.context" inputId="context" binary />
                    <label for="context">{{ getContextLabel }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
